import Link from "next/link";
import { useRouter } from "next/router";
import MobileOpenSideNav from "./MobileOpenSideNav";
import { Flex } from "@radix-ui/themes";

const acronymList = {
    "api": "API",
    "defi": "DeFi",
    "faq": "FAQ",
    "cqt": "CQT",
    "nft": "NFT",
    "sdk": "SDK"
};

const mapper = (s: string) => {
    switch (s) {
        case "networks":
            return "Supported Networks";
        default:
            return s;
    }
};

export const capitalizeFirstLetterAndRemoveDash = (string: string) => {
    const words = string.split("-");

    const capitalized = words.map((word) => {
        if (acronymList[word]) {
            return acronymList[word];
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
    });

    return capitalized.join(" ");
};

export const BreadCrumb = ({ title }) => {
    const router = useRouter();
    const path = router.asPath;
    const segments = path.split("/").filter((x) => x !== "").slice(0, -1);
    const structuredData = `
    {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [${segments.map((segment, index) => {
        const href = "/" + segments.slice(0, index + 1).join("/");
        return `{
                    "@type": "ListItem",
                    "position": ${index + 1},
                    "name": "${capitalizeFirstLetterAndRemoveDash(mapper(segment))}",
                    "item": "https://www.covalenthq.com${href}"
        }`;
    })}
        ,{
            "@type": "ListItem",
            "position": ${segments.length + 1},
            "name": "${title}",
            "item": "https://www.covalenthq.com${router.asPath}"
        }
       ]
    }
`;
    return <>
        <script id="structured-data" type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: structuredData
            }}
        />
        <div className="flex no-print" id="breadcrumb">
            {segments.map((segment, index) => {
                const href = "/" + segments.slice(0, index + 1).join("/");
                return <Flex key={index} align="center" gap="2" mr="2">
                    <span className="link">
                        <Link className="breadcrumb__link" href={href}>
                            {capitalizeFirstLetterAndRemoveDash(mapper(segment))}
                        </Link>
                    </span>
                    <span className="material-symbols-rounded">chevron_right</span>
                </Flex>;
            })}
            <span className="link"> {title} </span>
            <div className="last">
                <MobileOpenSideNav />
            </div>
        </div>
        <style jsx>{`
        div {
            margin-bottom: var(--default-vertical-spacing);
        }
        :global(.breadcrumb__link) {
            text-decoration: none;
        }
        :global(.breadcrumb__link:hover) {
            text-decoration: underline;
            color: var(--pink);
        }
        .link {
            flex: 1;
            place-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        @media screen and (max-width: 767px) {
            .link {
                flex: 1;
                place-items: center;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .flex {
                width: auto;
                place-items: center;
                background: var(--code-background);
                margin-left: -1rem;
                margin-right: -1rem;
                padding-left: 1rem;
                padding-right: 1rem;
                padding-bottom: 1rem;
                margin-top: 0;
                border-bottom: 1px solid var(--code-border);
                align-items: center;
            }
            .flex .last {
                margin-bottom: 0;
                margin-left: auto;
            }
        }
    }
    `}</style></>;
};